import createStore from './create';

const initialState = {
  selectedGroup: 0,
  selectedCard: 0,
  personName: '',
  origen: '',
  mostrarReferidos: false,
};

const useStore = createStore(initialState);
export default useStore;
